module.exports = __webpack_public_path__ + "static/media/not-interested.233f9429.svg";